import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#0a1628]/95 backdrop-blur-md shadow-lg shadow-black/20'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src="https://static.readdy.ai/image/8dbd60c8f218d42716666e4ddaa548a8/e10d3fd4f000823b1408934f8a9fe8ab.png"
                alt="AMM Management Group Logo"
                className="h-12 w-auto"
              />
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#services"
                className="text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] transition-colors cursor-pointer"
              >
                Services
              </a>
              <a
                href="#process"
                className="text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] transition-colors cursor-pointer"
              >
                Process
              </a>
              <a
                href="#faq"
                className="text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] transition-colors cursor-pointer"
              >
                FAQs
              </a>
              <a
                href="#resources"
                className="text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] transition-colors cursor-pointer"
              >
                Resources
              </a>
              <a
                href="#contact"
                className="text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] transition-colors cursor-pointer"
              >
                Contact
              </a>
              <Link
                to="/client-portal"
                className="px-6 py-2.5 bg-[#00e5c7] text-[#0a1628] rounded-md text-sm uppercase tracking-widest font-semibold hover:bg-[#00ccb0] transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-[#00e5c7]/20"
              >
                Client Portal
              </Link>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden cursor-pointer"
              aria-label="Toggle menu"
            >
              <i
                className={`${
                  mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
                } text-2xl text-white`}
              ></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#0a1628]/98 backdrop-blur-md border-t border-white/10">
            <div className="px-8 py-6 space-y-5">
              <a
                href="#services"
                className="block text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Services
              </a>
              <a
                href="#process"
                className="block text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Process
              </a>
              <a
                href="#faq"
                className="block text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                FAQs
              </a>
              <a
                href="#resources"
                className="block text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Resources
              </a>
              <a
                href="#contact"
                className="block text-sm uppercase tracking-widest text-white/80 hover:text-[#00e5c7] cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </a>
              <Link
                to="/client-portal"
                className="block px-6 py-2.5 bg-[#00e5c7] text-[#0a1628] rounded-md text-sm uppercase tracking-widest text-center font-semibold whitespace-nowrap cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Client Portal
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Content */}
      <div className="relative min-h-screen flex items-center">
        {/* Background */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/d21f57210edb59ca9ef5d3f9de249f2e.jpg"
            alt="Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#0a1628]/95 via-[#0d1f3c]/90 to-[#0a1628]/80"></div>
          {/* Edgy diagonal accent line */}
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#00e5c7] to-transparent opacity-40"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-8 py-32 grid md:grid-cols-2 gap-16 items-center w-full">
          <div>
            <div className="inline-flex items-center gap-2 mb-6">
              <div className="w-8 h-px bg-[#00e5c7]"></div>
              <span className="text-[#00e5c7] text-xs uppercase tracking-[0.3em] font-semibold">
                Tax Strategy &amp; Preparation
              </span>
            </div>
            <h1
              className="text-5xl md:text-7xl font-bold text-white leading-tight mb-8"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Strategic Tax
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00e5c7] to-[#00b4d8]">
                Solutions
              </span>{' '}
              for
              <br />
              Modern Business
            </h1>
            <p className="text-base text-[#8a9bb5] mb-10 leading-relaxed max-w-lg">
              Navigate complex tax landscapes with confidence. Our expert
              team delivers personalized tax strategy and preparation services
              designed to maximize your financial success.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="inline-flex items-center px-8 py-4 bg-[#00e5c7] text-[#0a1628] text-sm uppercase tracking-widest font-bold rounded-md shadow-lg shadow-[#00e5c7]/25 hover:shadow-[#00e5c7]/40 hover:bg-[#00ccb0] transition-all whitespace-nowrap cursor-pointer"
              >
                Start Planning
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#services"
                className="inline-flex items-center px-8 py-4 border border-white/20 text-white text-sm uppercase tracking-widest rounded-md hover:border-[#00e5c7]/50 hover:text-[#00e5c7] transition-all whitespace-nowrap cursor-pointer"
              >
                Our Services
              </a>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="bg-white/5 backdrop-blur-md rounded-lg p-8 border border-white/10 shadow-2xl relative overflow-hidden">
              {/* Corner accent */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl from-[#00e5c7]/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 w-16 h-16 bg-gradient-to-tr from-[#00e5c7]/10 to-transparent"></div>

              <div className="text-[#00e5c7] text-xs uppercase tracking-[0.3em] font-semibold mb-6">
                2024 Tax Deadline Tracker
              </div>
              <div className="space-y-5">
                <div className="flex justify-between items-center pb-5 border-b border-white/10">
                  <span className="text-white/70 text-sm">Q4 Estimated Tax</span>
                  <span
                    className="text-white text-2xl font-bold"
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                  >
                    Jan 15
                  </span>
                </div>
                <div className="flex justify-between items-center pb-5 border-b border-white/10">
                  <span className="text-white/70 text-sm">Individual Returns</span>
                  <span
                    className="text-white text-2xl font-bold"
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                  >
                    Apr 15
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-white/70 text-sm">Extension Deadline</span>
                  <span
                    className="text-white text-2xl font-bold"
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                  >
                    Oct 15
                  </span>
                </div>
              </div>
              <div className="mt-8 pt-6 border-t border-white/10">
                <p className="text-[#8a9bb5] text-sm">
                  Stay ahead of critical tax deadlines with our comprehensive
                  planning services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
